module.exports = __webpack_public_path__ + "static/media/Debbie-Knox-Hewson.ae2aed64.jpg";